// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-snack--bookmark-hint .v-snack__wrapper{max-width:230px;min-width:230px}.v-snack--bookmark-hint .v-snack__action{margin:0;position:absolute;right:4px;top:4px}.v-snack--bookmark-hint .v-snack__content{padding:12px}#main-env-label{font-size:100px;font-weight:700;height:0;opacity:.25;overflow:visible;pointer-events:none;position:absolute;word-wrap:normal;right:48px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
